import { FC } from 'react';
import { TabBase } from './types';

export type WbTabItemProps = TabBase & {
  disabled?: boolean;
  className?: string;
  title: string;
};

export const WbTabItem: FC<WbTabItemProps> = () => {
  // this is a proxy element, WbTabs parse this and substitutes with a MUI Tab element, because we cannot wrap MUI Tab element with a custom element or it will break MUI Tabs/Tab association
  return null;
};
